import { Component } from '@angular/core';

@Component({
  templateUrl: 'welcome.component.html'
})
export class PuiWelcomeComponent {}
